/**
 * @ngdoc directive
 * @name directiveRaceReplay
 * @restrict A
 *
 * @description
 * Directive for List View where fast results expected
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveFastResultTriggerCtrl' // Executes before compile
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/fastResultTrigger.js